<div class="users" *ngIf="isDataLoaded" [class.compact-cols]="isBeecher || isMidMarket">
  <div class="user-list-header">
    <cygov-checkbox class="user-list-checkbox" [isChecked]="allUserSelected" cygovUserPermission
      (changed)="onSelectAll($event)">
    </cygov-checkbox>
    <cygov-user-list-header (onDeleted)="onDeleted($event)" (onUnselectAll)="onSelectAll(false)"
      [selectedUsers]="selectedUsers" [userList]="userList" (onSortChanged)="onSortChanged($event)"
      [isEditMode]="isEditMode">
    </cygov-user-list-header>
  </div>
  <!-- <div class="horizontal-separator"></div> -->
  <div class="users-wrapper" [ngStyle]="{'width': userListToShow.length > 9 ? '102%': '101.3%'}">
    <div *ngFor="let viewPortItem of userListToShow;let i = index" class="td-users d-flex">
      <div class="user-item-margin"
        *ngIf="(showUserDetail && viewPortItem.id == selectedUser) || !showUserDetail">
        <div class="user-item-container" [ngClass]="{ 'selected': viewPortItem.isSelected  }"
          (click)="viewPortItem?.isLowerRank && toggleList(viewPortItem)">
          <div *ngIf="(currentUserId !== viewPortItem.user.id);then checkbox else spaces">
          </div>
          <ng-template #checkbox>
            <cygov-checkbox class="user-list-checkbox" [id]="'user_'+ viewPortItem.id"
              [isChecked]="viewPortItem.isSelected" cygovUserPermission
              (changed)="viewPortItem?.isLowerRank && viewPortItem.isSelected = $event; updateSelected(viewPortItem)">
            </cygov-checkbox>
          </ng-template>
          <ng-template #spaces>
            <div [ngClass]="{'extra-space': !isViewOnly }"></div>
          </ng-template>
          <cygov-user-item (onUpdateItem)="onUpdateItem($event)" class="user-item"
            [item]="viewPortItem" [isEditable]="viewPortItem?.isLowerRank"
            [isVendorUser]="isVendorUser(viewPortItem?.user)" [rolesList]="rolesList"
            [childEntities]="childEntities" [vendorEntities]="vendorHashEntities"
            [rootEntity]="rootEntity" (userUpdated)="isSetUpdate($event, viewPortItem)"
            [currentUser]="currentUser" [openUpwards]="getOpenUpwards(i, userListToShow.length)">
          </cygov-user-item>
        </div>
        <div class="container-fluid userDetailTabSet"
          *ngIf="(isLoading || showUserDetail) && viewPortItem.id === selectedUser">
        </div>
      </div>
    </div>
    <div *ngIf="userList.length === 0" class="td-users d-flex-c no-record">
      No Record Found
    </div>
    <div *cygovLoader="isLoading"></div>
  </div>
</div>